import { get, set } from 'idb-keyval';
import { httpsCallable, getFunctions } from 'firebase/functions';
import { functions }  from "../firebase/firebase.js";
import { getDocs } from 'firebase/firestore';

export async function getCallableCachedData(fnName, cacheKey, args = {}, refreshInterval = 600_000) {
  const tsKey = `${cacheKey}_ts`;
  const [cached, ts] = await Promise.all([get(cacheKey), get(tsKey)]);
  const now = Date.now();

  const isFresh = cached && ts && now - ts < refreshInterval;
  if (isFresh) return cached;

  try {
	//const functions = getFunctions();
    const fn = httpsCallable(functions, fnName);
    const result = await fn(args);
    const data = result.data;

    await set(cacheKey, data);
    await set(tsKey, now);
    localStorage.setItem('cache_update', `${cacheKey}|${now}`);
    return data;
  } catch (err) {
    console.error('[getCallableCachedData]', err);
    throw err;
  }
}

export async function getCallableCache(fnName, cacheKey, args = {}, refreshInterval = 600_000) {
  const tsKey = `${cacheKey}_timestamp`;
  const cached = localStorage.getItem(cacheKey);
  const ts = localStorage.getItem(tsKey);
  const now = Date.now();

  const isFresh = cached && ts && now - Number(ts) < refreshInterval;
  if (isFresh) return JSON.parse(cached);

  //const functions = getFunctions();
  const fn = httpsCallable(functions, fnName);
  const result = await fn(args);
  localStorage.setItem(cacheKey, JSON.stringify(result.data));
  localStorage.setItem(tsKey, now.toString());
  return result.data;
}


export async function getFirestoreCache(queryObj, cacheKey, refreshInterval = 600_000) {
  const tsKey = `${cacheKey}_timestamp`;
  const cached = localStorage.getItem(cacheKey);
  const ts = localStorage.getItem(tsKey);
  const now = Date.now();

  const isFresh = cached && ts && now - Number(ts) < refreshInterval;
  if (isFresh) return JSON.parse(cached);

  const snap = await getDocs(queryObj);
  const result = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  localStorage.setItem(cacheKey, JSON.stringify(result));
  localStorage.setItem(tsKey, now.toString());
  return result;
}


export async function getFirestoreCacheWithDB(queryObj, cacheKey, refreshInterval = 600_000) {
  const tsKey = `${cacheKey}_ts`;
  const [cached, ts] = await Promise.all([get(cacheKey), get(tsKey)]);
  const now = Date.now();

  if (cached && ts && now - ts < refreshInterval) return cached;

  const snap = await getDocs(queryObj);
  const result = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  await set(cacheKey, result);
  await set(tsKey, now);
  localStorage.setItem('cache_update', `${cacheKey}|${now}`);
  return result;
}



/*
useEffect(() => {
  async function fetchInitialData() {
    const leaderboard = await getCallableCachedData('getPublicLeaderboard', 'leaderboard_cache');
    console.log('Cached Leaderboard:', leaderboard);
  }

  fetchInitialData();
}, []);
*/